<template>
  <v-layout layout row wrap mx-0 white pa-5>
    
    
    <h2  class="title w-100">Enviar códigos promocionales entre:</h2>
    
    <br />
    <br />
    
    <v-flex xs12 sm6 md4>
      <v-menu
        ref="menu1"
        v-model="menu1"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        max-width="290px"
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :value="fechas_suscripcion.fecha_inicio != undefined ? formatDate(fechas_suscripcion.fecha_inicio) : undefined"
            label="Fecha de inicio"
            prepend-icon="event"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker v-model="fechas_suscripcion.fecha_inicio" no-title @input="menu1 = false" locale="es-es"></v-date-picker>
      </v-menu>
    </v-flex>
    
    <v-spacer></v-spacer>
    
    <v-flex xs12 sm6 md4>
        <v-menu
          ref="menu2"
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          max-width="290px"
          min-width="290px"
        >
        <template v-slot:activator="{ on }">
          <v-text-field
            :value="fechas_suscripcion.fecha_fin != undefined ? formatDate(fechas_suscripcion.fecha_fin) : undefined"
            label="Fecha de fin"
            prepend-icon="event"
            readonly
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker v-model="fechas_suscripcion.fecha_fin" no-title @input="menu2 = false" locale="es-es"></v-date-picker>
      </v-menu>
    </v-flex>

    <v-spacer></v-spacer>
    
    <v-flex xs12 sm12 text-xs-center mt-5>
      <div>
        <v-btn color="success" large @click="saveAction">Guardar</v-btn>
      </div>
      
    </v-flex>
    
  </v-layout>
</template>

<script>
import moment from 'moment'

export default {
	data() {
		return {
      titlePage: 'Configuración',
      fechas_suscripcion : {},
      menu1: false,
      menu2: false
		}
	},
  methods: {
		saveAction() {
			
				this.$store.commit('setLoading', true)

					this.$connector.put('configuracion', {url: 'configuracion', id: 'ZCCUFShW5PIhPOUAeLxa', data: this.fechas_suscripcion})
					.then(() => { 
							this.$store.commit('setActiveSnackbar', true)
							this.$store.commit('setLoading', false)
					})
					.catch((error) => {
							console.error("Error adding document: ", error);
					});
		},
    formatDate(date) {
      if (date.seconds) {
        return moment.unix(date.seconds).format('DD/MM/YYYY')
      } else if(date) {
        return moment(date).format('DD/MM/YYYY')
      }
		}
	},
  created() {
    this.$store.commit('setLoading', true)
    
    // setear toolbar
		var toolbarOpt = {
			title: this.titlePage,
			path: this.$route.fullPath,
			actions: [
				{icon: 'save', action: this.saveAction}
			]
		}
    
    this.$connector.get('configuracion', {url: 'configuracion', id: 'ZCCUFShW5PIhPOUAeLxa'})
    .then(doc => {
      if(doc.exists) {
        var data = doc.data()
        this.titlePage, toolbarOpt.title = 'Editar configuración'
        this.fechas_suscripcion = data
        this.$store.commit('toolbarOptions', toolbarOpt)
      }
      this.$store.commit('setLoading', false)
    })
    
  }
}
</script>
